<template>
  <el-form
    ref="form"
    label-position="top"
    :model="form"
    :rules="rules"
    @submit.native.prevent="submit"
  >
    <h1>Konto verwalten</h1>

    <el-form-item>
      <c-button-link
        round
        :to="{ name: 'account-password' }"
      >
        Passwort ändern
      </c-button-link>

      <c-button-link
        plain
        round
        :to="{ name: 'account-delete' }"
        type="danger"
      >
        Konto löschen
      </c-button-link>
    </el-form-item>

    <p>
      Ihre hinterlegte E-Mail-Adresse:<br>
      <strong>{{ $store.state.user.profile.email }}</strong>
    </p>

    <h2>Persönliche Daten</h2>
    <c-account-form-coachee-personal :form="form" />

    <h2>Angaben zur Schule</h2>
    <c-account-form-coachee-school :form="form" />

    <el-form-item>
      <el-button
        :loading="submitStatus === $config.status.LOADING"
        native-type="submit"
        round
        type="primary"
      >
        Speichern
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import CAccountFormCoacheePersonal from '@/components/CAccountFormCoacheePersonal'
import CAccountFormCoacheeSchool from '@/components/CAccountFormCoacheeSchool'
import CButtonLink from '@/components/CButtonLink'

import api from '@/api'
import validators from '@/functions/validators'

export default {
  name: 'VAccountCoachee',

  metaInfo: {
    title: 'Konto verwalten'
  },

  components: {
    CAccountFormCoacheePersonal,
    CAccountFormCoacheeSchool,
    CButtonLink
  },

  data () {
    return {
      submitStatus: this.$config.status.IDLE,
      form: {
        firstName: this.$store.state.user.profile.firstName,
        lastName: this.$store.state.user.profile.lastName,
        phone: this.$store.state.user.profile.phone,
        phoneMobile: this.$store.state.user.profile.phoneMobile,
        school: this.$store.state.user.profile.school,
        position: this.$store.state.user.profile.position,
        schoolType: this.$store.state.user.profile.schoolType
      },
      rules: {
        firstName: {
          required: true,
          message: 'Bitte geben Sie Ihren Vornamen ein.'
        },
        lastName: {
          required: true,
          message: 'Bitte geben Sie Ihren Nachnamen ein.'
        },
        phone: [
          {
            required: true,
            message: 'Bitte geben Sie Ihre Telefonnummer ein.'
          },
          {
            validator (rule, value, callback) {
              validators.phoneNumber({
                value,
                message: 'Bitte geben Sie nur Zahlen und Sonderzeichen ein – keine Buchstaben.',
                callback
              })
            }
          }
        ],
        phoneMobile: {
          validator (rule, value, callback) {
            validators.phoneNumber({
              value,
              message: 'Bitte geben Sie nur Zahlen und Sonderzeichen ein – keine Buchstaben.',
              callback
            })
          }
        },
        school: {
          required: true,
          message: 'Bitte geben Sie den Namen Ihrer Schule ein.'
        },
        position: {
          required: true,
          message: 'Bitte wählen Sie Ihre Position.'
        },
        schoolType: {
          required: true,
          message: 'Bitte wählen Sie die Schulform.'
        }
      }
    }
  },

  methods: {
    submit () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }

        this.submitStatus = this.$config.status.LOADING

        api.coachee
          .update(this.$store.state.user.profile.id, this.form)
          .then(() => {
            this.$notify.success({
              title: 'Konto aktualisiert',
              message: 'Ihr Konto wurde erfolgreich aktualisiert.'
            })

            this.submitStatus = this.$config.status.SUCCESS
            this.$router.push({ name: 'index' })
          })
          .catch(() => {
            this.$notify.error({
              title: 'Fehler',
              message: 'Ihr Profil konnte leider nicht aktualisiert werden.'
            })

            this.submitStatus = this.$config.status.ERROR
          })
      })
    }
  }
}
</script>
